/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_Before_ConsentInputs */

const en_privacy_section_4_before_consent = /** @type {(inputs: Privacy_Section_4_Before_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before consent`)
};

const lv_privacy_section_4_before_consent = /** @type {(inputs: Privacy_Section_4_Before_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirms piekrišanas`)
};

/**
* | output |
* | --- |
* | "Before consent" |
*
* @param {Privacy_Section_4_Before_ConsentInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_before_consent = /** @type {((inputs?: Privacy_Section_4_Before_ConsentInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_Before_ConsentInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_before_consent(inputs)
	return en_privacy_section_4_before_consent(inputs)
});